import { useState } from 'react';

const HomePage = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  const registrationLink = 'https://tevau.io/invite_registration/#/?inviteCode=182874';

  const features = [
    {
      icon: 'ri-exchange-line',
      title: '即時変換',
      description: '購入時にUSDTを自動的に法定通貨に変換。変換手数料なし。'
    },
    {
      icon: 'ri-shield-check-line',
      title: '安全でコンプライアンス準拠',
      description: '完全な規制の透明性を備えたエンタープライズグレードのセキュリティ。'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: '低料金',
      description: '予期せぬ料金や隠れた値上げはありません。'
    },
    {
      icon: 'ri-global-line',
      title: 'グローバル利用',
      description: 'Visa加盟店で世界中どこでもご利用可能。'
    },
    {
      icon: 'ri-smartphone-line',
      title: 'ユーザーフレンドリー',
      description: 'iOS/Android対応アプリで簡単管理。'
    },
    {
      icon: 'ri-percent-line',
      title: '最大4.5% APR',
      description: '遊休資金をサブスクライブして時間ごとに報酬獲得。'
    }
  ];

  const cardTypes = [
    {
      title: '物理カード',
      features: ['ATM引き出し対応', 'リアルタイム取引', 'スワイプ＆タップ決済', '世界中のVisa加盟店で利用可能'],
      image: 'https://www.tevau.co/wp-content/uploads/2025/05/CARD.png'
    },
    {
      title: 'バーチャルカード',
      features: ['オンライン決済専用', '即時発行', '広く受け入れられている', 'サブスクリプション支払いに最適'],
      image: 'https://www.tevau.co/wp-content/uploads/2025/05/card6.-p1WkWED.png'
    }
  ];

  const steps = [
    {
      number: '01',
      title: 'アプリをダウンロード',
      description: 'App StoreまたはGoogle PlayからTevauアプリをダウンロード'
    },
    {
      number: '02',
      title: 'アカウント登録',
      description: '招待コードを使用してアカウントを作成し、本人確認を完了'
    },
    {
      number: '03',
      title: 'USDTを入金',
      description: 'ウォレットにUSDTを入金してカードにチャージ'
    },
    {
      number: '04',
      title: '利用開始',
      description: '世界中のVisa加盟店でお買い物を楽しむ'
    }
  ];

  const faqs = [
    {
      question: 'TEVAUカードとは何ですか？',
      answer: 'TEVAUカードは、USDTなどの暗号通貨を日常の支払いに使用できるVisaデビットカードです。購入時に自動的に法定通貨に変換されるため、世界中のVisa加盟店でシームレスに利用できます。'
    },
    {
      question: 'どの暗号通貨に対応していますか？',
      answer: '主にUSDT（テザー）に対応しています。USDTは米ドルに連動したステーブルコインで、価格変動が少なく日常の支払いに最適です。'
    },
    {
      question: 'カードの発行手数料はいくらですか？',
      answer: '物理カードとバーチャルカードで異なります。詳細な料金体系はアプリ内でご確認いただけます。隠れた手数料はありません。'
    },
    {
      question: 'ATMで現金を引き出せますか？',
      answer: 'はい、物理カードをお持ちの場合、世界中のVisa対応ATMで現金を引き出すことができます。'
    },
    {
      question: '最大4.5% APRの獲得方法は？',
      answer: 'Tevauアプリの「獲得」機能を使用して、未使用のウォレット資金をサブスクライブすると、時間ごとに報酬を獲得できます。いつでも解約可能な柔軟性があります。'
    },
    {
      question: 'セキュリティは大丈夫ですか？',
      answer: 'Tevauは高度なブロックチェーン技術を使用し、完全なライセンスを取得して金融規制に準拠しています。エンタープライズグレードのセキュリティで資産を保護します。'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm z-50 border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center gap-2">
              <img 
                src="https://www.tevau.co/wp-content/uploads/2025/05/logo-tevau.png" 
                alt="TEVAU" 
                className="h-8"
              />
            </div>
            <nav className="hidden md:flex items-center gap-8">
              <a href="#about" className="text-gray-600 hover:text-gray-900 text-sm font-medium">TEVAUとは</a>
              <a href="#cards" className="text-gray-600 hover:text-gray-900 text-sm font-medium">カード種類</a>
              <a href="#features" className="text-gray-600 hover:text-gray-900 text-sm font-medium">特徴</a>
              <a href="#howto" className="text-gray-600 hover:text-gray-900 text-sm font-medium">始め方</a>
              <a href="#faq" className="text-gray-600 hover:text-gray-900 text-sm font-medium">よくある質問</a>
            </nav>
            <a 
              href={registrationLink}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#BFFF00] text-black px-6 py-2.5 rounded-full text-sm font-bold hover:bg-[#a8e600] transition-colors cursor-pointer whitespace-nowrap"
            >
              今すぐ申込む
            </a>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-20 left-10 w-72 h-72 bg-[#BFFF00] rounded-full filter blur-3xl"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#BFFF00] rounded-full filter blur-3xl"></div>
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
                <span className="w-2 h-2 bg-[#BFFF00] rounded-full animate-pulse"></span>
                <span className="text-sm">Visa決済ネットワーク対応</span>
              </div>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
                暗号通貨を<br />
                <span className="text-[#BFFF00]">現金のように</span><br />
                使える時代へ
              </h1>
              <p className="text-lg text-gray-300 mb-8 leading-relaxed">
                TEVAUカードは、USDTを世界中のVisa加盟店で使えるデビットカードです。
                複雑な手続きなし、即時変換、低手数料で暗号通貨決済を実現。
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <a 
                  href={registrationLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-[#BFFF00] text-black px-8 py-4 rounded-full text-lg font-bold hover:bg-[#a8e600] transition-colors cursor-pointer text-center whitespace-nowrap inline-flex items-center justify-center gap-2"
                >
                  <span>無料で申込む</span>
                  <i className="ri-arrow-right-line"></i>
                </a>
                <a 
                  href="#about"
                  className="border border-white/30 text-white px-8 py-4 rounded-full text-lg font-medium hover:bg-white/10 transition-colors cursor-pointer text-center whitespace-nowrap"
                >
                  詳しく見る
                </a>
              </div>
              <div className="flex items-center gap-8 mt-10">
                <div>
                  <div className="text-3xl font-bold text-[#BFFF00]">500,000+</div>
                  <div className="text-sm text-gray-400">取引完了</div>
                </div>
                <div>
                  <div className="text-3xl font-bold text-[#BFFF00]">50k+</div>
                  <div className="text-sm text-gray-400">ダウンロード</div>
                </div>
                <div>
                  <div className="text-3xl font-bold text-[#BFFF00]">4.5%</div>
                  <div className="text-sm text-gray-400">最大APR</div>
                </div>
              </div>
            </div>
            <div className="relative">
              <img 
                src="https://www.tevau.co/wp-content/uploads/2025/05/tevau-bannerhone.png" 
                alt="TEVAU App" 
                className="w-full max-w-md mx-auto"
              />
            </div>
          </div>
        </div>
      </section>

      {/* What is TEVAU */}
      <section id="about" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <span className="text-[#BFFF00] bg-gray-900 px-4 py-1 rounded-full text-sm font-medium">TEVAUとは</span>
            <h2 className="text-3xl md:text-4xl font-bold mt-6 mb-4">暗号通貨と現実世界をつなぐ架け橋</h2>
            <p className="text-gray-600 max-w-3xl mx-auto text-lg">
              TEVAUは、USDTなどの暗号通貨を日常の支払いに使用できるVisaデビットカードサービスです。
              複雑なスワップや遅延、制限なしで、いつでもどこでも暗号通貨決済を実現します。
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div className="bg-white rounded-3xl p-8 shadow-lg">
              <h3 className="text-2xl font-bold mb-6">こんな場面で使えます</h3>
              <div className="grid grid-cols-2 gap-4">
                {['夕食代を支払う', 'ホテルを予約', '航空券を購入', 'ガソリン代を支払う', 'オンラインショッピング', 'サブスクリプション', '投資', 'ATM引き出し'].map((item, index) => (
                  <div key={index} className="flex items-center gap-2">
                    <i className="ri-check-line text-[#BFFF00] text-xl"></i>
                    <span className="text-gray-700">{item}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="space-y-6">
              <div className="bg-white rounded-2xl p-6 shadow-md">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#BFFF00]/20 rounded-xl flex items-center justify-center">
                    <i className="ri-flashlight-line text-2xl text-gray-900"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-lg mb-2">即時変換</h4>
                    <p className="text-gray-600">購入時にUSDTが自動的に法定通貨に変換されます。</p>
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-2xl p-6 shadow-md">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#BFFF00]/20 rounded-xl flex items-center justify-center">
                    <i className="ri-global-line text-2xl text-gray-900"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-lg mb-2">世界中で利用可能</h4>
                    <p className="text-gray-600">Visa加盟店ならどこでも使えます。</p>
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-2xl p-6 shadow-md">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#BFFF00]/20 rounded-xl flex items-center justify-center">
                    <i className="ri-shield-check-line text-2xl text-gray-900"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-lg mb-2">安全・安心</h4>
                    <p className="text-gray-600">完全ライセンス取得、金融規制準拠。</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Card Types */}
      <section id="cards" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <span className="text-[#BFFF00] bg-gray-900 px-4 py-1 rounded-full text-sm font-medium">カード種類</span>
            <h2 className="text-3xl md:text-4xl font-bold mt-6 mb-4">あなたに合ったカードを選ぶ</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              物理カードとバーチャルカード、用途に合わせてお選びいただけます。
            </p>
          </div>

          <div className="flex justify-center mb-8">
            <div className="bg-gray-100 p-1 rounded-full inline-flex">
              {cardTypes.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setActiveTab(index)}
                  className={`px-6 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                    activeTab === index 
                      ? 'bg-gray-900 text-white' 
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  {cardTypes[index].title}
                </button>
              ))}
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="order-2 md:order-1">
              <h3 className="text-3xl font-bold mb-6">{cardTypes[activeTab].title}</h3>
              <ul className="space-y-4 mb-8">
                {cardTypes[activeTab].features.map((feature, index) => (
                  <li key={index} className="flex items-center gap-3">
                    <div className="w-6 h-6 bg-[#BFFF00] rounded-full flex items-center justify-center">
                      <i className="ri-check-line text-sm text-gray-900"></i>
                    </div>
                    <span className="text-gray-700 text-lg">{feature}</span>
                  </li>
                ))}
              </ul>
              <a 
                href={registrationLink}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gray-900 text-white px-8 py-4 rounded-full text-lg font-bold hover:bg-gray-800 transition-colors cursor-pointer inline-flex items-center gap-2 whitespace-nowrap"
              >
                <span>{cardTypes[activeTab].title}を申込む</span>
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
            <div className="order-1 md:order-2 flex justify-center">
              <img 
                src={cardTypes[activeTab].image} 
                alt={cardTypes[activeTab].title}
                className="max-w-sm w-full"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Features */}
      <section id="features" className="py-20 bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <span className="text-gray-900 bg-[#BFFF00] px-4 py-1 rounded-full text-sm font-medium">特徴</span>
            <h2 className="text-3xl md:text-4xl font-bold mt-6 mb-4">TEVAUが選ばれる理由</h2>
            <p className="text-gray-400 max-w-2xl mx-auto">
              暗号通貨の柔軟性と従来の金融を組み合わせ、デジタル資産をどこでも簡単に利用できます。
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map((feature, index) => (
              <div key={index} className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 hover:bg-white/10 transition-colors">
                <div className="w-12 h-12 bg-[#BFFF00]/20 rounded-xl flex items-center justify-center mb-4">
                  <i className={`${feature.icon} text-2xl text-[#BFFF00]`}></i>
                </div>
                <h3 className="text-xl font-bold mb-2">{feature.title}</h3>
                <p className="text-gray-400">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How to Start */}
      <section id="howto" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <span className="text-[#BFFF00] bg-gray-900 px-4 py-1 rounded-full text-sm font-medium">始め方</span>
            <h2 className="text-3xl md:text-4xl font-bold mt-6 mb-4">4ステップで簡単スタート</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              数分でアカウント作成、すぐにカードを利用開始できます。
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                <div className="bg-gray-50 rounded-2xl p-6 h-full">
                  <div className="text-5xl font-bold text-[#BFFF00]/30 mb-4">{step.number}</div>
                  <h3 className="text-xl font-bold mb-2">{step.title}</h3>
                  <p className="text-gray-600">{step.description}</p>
                </div>
                {index < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2">
                    <i className="ri-arrow-right-line text-2xl text-gray-300"></i>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <a 
              href={registrationLink}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#BFFF00] text-black px-10 py-4 rounded-full text-lg font-bold hover:bg-[#a8e600] transition-colors cursor-pointer inline-flex items-center gap-2 whitespace-nowrap"
            >
              <span>今すぐ始める</span>
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section id="faq" className="py-20 bg-gray-50">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <span className="text-[#BFFF00] bg-gray-900 px-4 py-1 rounded-full text-sm font-medium">よくある質問</span>
            <h2 className="text-3xl md:text-4xl font-bold mt-6 mb-4">FAQ</h2>
          </div>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-white rounded-2xl shadow-sm overflow-hidden">
                <button
                  onClick={() => setOpenFaq(openFaq === index ? null : index)}
                  className="w-full px-6 py-4 text-left flex items-center justify-between cursor-pointer"
                >
                  <span className="font-bold text-lg">{faq.question}</span>
                  <i className={`ri-arrow-down-s-line text-2xl transition-transform ${openFaq === index ? 'rotate-180' : ''}`}></i>
                </button>
                {openFaq === index && (
                  <div className="px-6 pb-4">
                    <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gray-900 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            今すぐTEVAUカードを<br />
            <span className="text-[#BFFF00]">手に入れよう</span>
          </h2>
          <p className="text-gray-400 text-lg mb-8">
            暗号通貨を現金のように使える新しい時代へ。<br />
            無料でアカウント作成、数分で利用開始。
          </p>
          <a 
            href={registrationLink}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#BFFF00] text-black px-12 py-5 rounded-full text-xl font-bold hover:bg-[#a8e600] transition-colors cursor-pointer inline-flex items-center gap-3 whitespace-nowrap"
          >
            <span>無料で申込む</span>
            <i className="ri-arrow-right-line text-2xl"></i>
          </a>
          <div className="flex justify-center gap-6 mt-8">
            <img 
              src="https://www.tevau.co/wp-content/uploads/2024/06/footer-b1.png" 
              alt="App Store" 
              className="h-10 cursor-pointer hover:opacity-80 transition-opacity"
            />
            <img 
              src="https://www.tevau.co/wp-content/uploads/2024/06/footer-b2.png" 
              alt="Google Play" 
              className="h-10 cursor-pointer hover:opacity-80 transition-opacity"
            />
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8 mb-8">
            <div>
              <img 
                src="https://www.tevau.co/wp-content/uploads/2025/05/logo-tevau.png" 
                alt="TEVAU" 
                className="h-8 mb-4"
              />
              <p className="text-gray-400 text-sm">
                暗号通貨と現実世界をつなぐ次世代決済ソリューション
              </p>
            </div>
            <div>
              <h4 className="font-bold mb-4">リンク</h4>
              <ul className="space-y-2 text-sm text-gray-400">
                <li><a href="#about" className="hover:text-white cursor-pointer">TEVAUとは</a></li>
                <li><a href="#cards" className="hover:text-white cursor-pointer">カード種類</a></li>
                <li><a href="#features" className="hover:text-white cursor-pointer">特徴</a></li>
                <li><a href="#faq" className="hover:text-white cursor-pointer">よくある質問</a></li>
              </ul>
            </div>
            <div>
              <h4 className="font-bold mb-4">コミュニティ</h4>
              <ul className="space-y-2 text-sm text-gray-400">
                <li><a href="https://t.me/tevau_community" target="_blank" rel="noopener noreferrer" className="hover:text-white cursor-pointer">Telegram</a></li>
                <li><a href="https://x.com/tevau_official" target="_blank" rel="noopener noreferrer" className="hover:text-white cursor-pointer">Twitter</a></li>
                <li><a href="https://www.instagram.com/tevau.co/" target="_blank" rel="noopener noreferrer" className="hover:text-white cursor-pointer">Instagram</a></li>
              </ul>
            </div>
            <div>
              <h4 className="font-bold mb-4">今すぐ申込む</h4>
              <a 
                href={registrationLink}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#BFFF00] text-black px-6 py-3 rounded-full text-sm font-bold hover:bg-[#a8e600] transition-colors cursor-pointer inline-block whitespace-nowrap"
              >
                カードを申込む
              </a>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">© 2025 Mind Mission. All Rights Reserved</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;
